<template>
  <div class="p-home">

    <Slides />

    <Footer />

  </div>
</template>

<script>
import Slides from '@/components/slides/slides.vue';
import Footer from '@/components/footer/footer.vue';

export default {
  components: {
    Slides,
    Footer,
  },
};
</script>
